import routes from 'actions/routes';
import { generateReadOneActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

const getTemplate = generateReadOneActionCreator(routes.API_TEMPLATE, ACTION_NAMES.TEMPLATE);

export default {
    getTemplate
}
